module.exports = __WEBPACK_EXTERNAL_MODULE_144__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 144
// module chunks = 0